import React, { useState, useEffect } from "react";
import {
  FaPhoneAlt,
  FaUsers,
  FaClock,
  FaChevronDown,
  FaChevronUp
} from "react-icons/fa";

const OrderCard = ({
  order,
  expandedId,
  toggleExpand,
  handleStatusUpdate
}) => {

  const [selectedStatus, setSelectedStatus] = useState(order.status);
  const [loading, setLoading] = useState(false);

  // Keep dropdown synced if WebSocket updates status
  useEffect(() => {
    setSelectedStatus(order.status);
  }, [order.status]);

  const formatTimeAgo = (minutes) => {
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  const updateStatus = async () => {
    if (selectedStatus === order.status) return;

    setLoading(true);
    await handleStatusUpdate(order.id, selectedStatus);
    setLoading(false);
  };

  return (
    <div className="kc-order-card">

      <div className="kc-card-header">
        <div>
          <div className="kc-table-number">{order.table}</div>
        </div>

        <div className="kc-status-block">
          <span className={`kc-status-badge ${order.status.toLowerCase()}`}>
            {order.status}
          </span>
          <div className="kc-time">
            <FaClock /> {formatTimeAgo(order.time)}
          </div>
        </div>
      </div>

      <div className="kc-customer-section">
        <div className="kc-customer-name">{order.name}</div>
        <div className="kc-customer-meta">
          <FaPhoneAlt /> {order.phone}
          <span className="kc-separator">|</span>
          <FaUsers /> {order.guests} guests
        </div>
        <div className="kc-order-time">{order.orderTime}</div>
      </div>

      <div
        className="kc-items-toggle"
        onClick={() => toggleExpand(order.id)}
      >
        <span>{order.items.length} items</span>
        {expandedId === order.id ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      {expandedId === order.id && (
        <div className="kc-items-content">
          {order.items.map((item, index) => (
            <div key={index} className="kc-item-row">
              <span>{item.name} ×{item.qty}</span>
              <span>₹{item.price}</span>
            </div>
          ))}

          <div className="kc-divider" />

          <div className="kc-billing-row">
            <span>Net Amount</span>
            <span>₹{order.billing.net.toFixed(2)}</span>
          </div>
          <div className="kc-billing-row">
            <span>CGST</span>
            <span>₹{order.billing.cgst.toFixed(2)}</span>
          </div>
          <div className="kc-billing-row">
            <span>SGST</span>
            <span>₹{order.billing.sgst.toFixed(2)}</span>
          </div>
          <div className="kc-billing-row">
            <span>Round Off</span>
            <span>₹{order.billing.round.toFixed(2)}</span>
          </div>

          <div className="kc-total-row">
            <span>Total</span>
            <span>₹{order.billing.total.toFixed(2)}</span>
          </div>
        </div>
      )}

      <div className="kc-card-footer">
        <select
          className="kc-status-select"
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          disabled={loading}
        >
          <option>PENDING</option>
          <option>CONFIRMED</option>
          <option>PREPARING</option>
          <option>READY</option>
          <option>SERVED</option>
          <option>CANCELLED</option>
        </select>

        <button
          className="kc-update-btn"
          onClick={updateStatus}
          disabled={loading || selectedStatus === order.status}
        >
          {loading ? "Updating..." : "Update"}
        </button>
      </div>

    </div>
  );
};

export default OrderCard;